<template>
  <v-app class="">
    <Navbar />
    <v-main class="mainBackground">
      <template>
        <v-progress-linear
          indeterminate
          color="yellow darken-2"
          :active="GetLoading"
        ></v-progress-linear>
      </template>
      <router-view></router-view>
    </v-main>
    <!-- <Footer /> -->

    <template>
      <div class="text-center">
        <v-snackbar
          v-model="GetMsg.snackbar"
          :timeout="GetMsg.timeout"
          :color="GetMsg.color"
        >
          {{ GetMsg.text }}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="#ffffff"
              text
              v-bind="attrs"
              @click="GetMsg.snackbar = false"
            >
              {{ $t("public.close") }}
            </v-btn>
          </template>
        </v-snackbar>
      </div>
    </template>
  </v-app>
</template>

<style>
* {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.mainBackground {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  background: url("assets/bg.png") no-repeat center center;
}



/* -------------- */

::-webkit-scrollbar {
  width: 5px;
  }
::-webkit-scrollbar-track {
  background-color: white;
  border-radius: 0;
  border-right: 0px solid #e6e6e6 ;
  border-left: 0px solid #e6e6e6 ;
  margin: 5px;
  
  border-top-width: 0 ;
  border-bottom-width: 0 ;
}
::-webkit-scrollbar-thumb {
  border-radius: 100px;
  border: 0px solid transparent;
  background-clip: content-box;
  background-color: #e6e6e6;

}

</style>
<script>
import Navbar from "@/components/Navbar";
// import Footer from "@/components/Footer";

export default {
  name: "App",
  metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'المكتبة الشاملة الذهبية',
      // all titles will be injected into this template
      titleTemplate: '%s | المكتبة الشاملة الذهبية'
    },
  components: { Navbar},
  computed: {
    GetMsg: function () {
      return this.$store.getters.getMsg;
    },
    GetLoading: function () {
      return this.$store.getters.getLoading;
    },
  },
};
</script>


